import { Component, OnDestroy, OnInit } from '@angular/core';
import { UiStateStore } from 'src/app/shared/store/ui-state-store.service';
import { Alert } from 'src/app/shared/models/alert';
import { EmployerStore } from 'src/app/dashboards/store/employer-store';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/dashboards/services/data.service';
import { Subscription } from 'rxjs';
import { AuthenticationResult } from '../../../../shared/models/authentication-result';
import { Navigation } from '../../../../shared/models/navigation';


@Component({
  selector: 'app-dashboard-employer-main',
  templateUrl: './dashboard-main.component.html',
  styleUrls: ['./dashboard-main.component.scss']
})
export class DashboardEmployerMainComponent implements OnInit, OnDestroy {

  private defaultPhotoPath: string = "assets/images/logo-emp.png";
  user: AuthenticationResult = null;
  navigations: Navigation[] = Navigation.getEmployerNavigations();
  photoPath: string;
  alert: Alert;
  staticAlertOpened: boolean;
  companyName: string = "Company Name";
  subscriptions: Subscription[] = [];
  
  constructor(private uiStore: UiStateStore, private store: EmployerStore, private dataService: DataService) {
    this.photoPath = this.defaultPhotoPath;
   }
  
  ngOnInit() {

    let userSubscription = this.uiStore.authenticatedUser.subscribe(user => {
      if (!user) {
        return;
      }
      
      this.user = user;
      this.dataService.getBusinessDetails(user.accountId).subscribe(details => { });
    });

    this.subscriptions.push(userSubscription);

    let photoSubscription = this.store.profilePhoto.subscribe(path => {
      if (!path) {
        this.photoPath = this.defaultPhotoPath;
        return;
      }

      this.photoPath = `${environment.baseUrl}/${path}`;
    });

    this.subscriptions.push(photoSubscription);

    let errorSubscription = this.uiStore.error.subscribe(error => {
      if (!error) {
        return;
      }

      this.alert = Alert.error(error);
      this.staticAlertOpened = true;
      setTimeout(() => this.staticAlertOpened = false, 20000);
    });

    this.subscriptions.push(errorSubscription);

    let successSubscription = this.uiStore.success.subscribe(message => {
      if (!message) {
        return;
      }

      this.alert = Alert.success(message);
      this.staticAlertOpened = true;
      setTimeout(() => this.staticAlertOpened = false, 20000);
    });

    this.subscriptions.push(successSubscription);

    let businessDetailsSubscription = this.store.BusinessDetails.subscribe(details => {
      if (!details) {
        this.photoPath = this.defaultPhotoPath;
        return;
      }
      
      this.companyName = details.companyName;
      if(details.photoPath)
        this.photoPath = `${environment.baseUrl}/${details.photoPath}`;
    });

    this.subscriptions.push(businessDetailsSubscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  closeAlert(): void {
    this.staticAlertOpened = false;
  }

}
